export const colorClasses: Record<string, Record<string, string>> = {
	primary: {
		red: "text-lightRed bg-secondaryRed hover:bg-darkRed",
		blue: "text-lightBlue bg-secondaryBlue hover:bg-darkBlue",
		green: "text-lightGreen bg-secondaryGreen hover:bg-darkGreen",

		roseWhite: "text-lightRoseWhite bg-secondaryRoseWhite hover:bg-darkRoseWhite",
		purple: "text-lightPurple bg-secondaryPurple hover:bg-darkPurple",
		violet: "text-lightViolet bg-secondaryViolet hover:bg-darkViolet",
		mutedViolet: "text-lightMutedViolet bg-secondaryMutedViolet hover:bg-darkMutedViolet",
		facebook: "text-white bg-[#1877F2] hover:bg-[#0d65d9]",
		instagram: "text-white bg-[#E1306C] hover:bg-[#C13584]",
		default: "text-white bg-primaryPurple hover:bg-darkPurple",
	},
	secondary: {
		red: "text-darkRed bg-lightRed hover:bg-primaryRed",
		blue: "text-white bg-primaryBlue hover:bg-secondaryBlue",
		green: "text-white bg-primaryGreen hover:bg-secondaryGreen",

		roseWhite: "text-darkRoseWhite bg-lightRoseWhite hover:bg-primaryRoseWhite",
		purple: "text-darkPurple bg-lightPurple hover:bg-primaryPurple",
		violet: "text-darkViolet bg-lightViolet hover:bg-primaryViolet",
		mutedViolet: "text-darkMutedViolet bg-lightMutedViolet hover:bg-primaryMutedViolet",
		facebook: "text-[#0d65d9] bg-[#DCE8FF] hover:bg-[#bdd5ff]",
		instagram: "text-[#C13584] bg-[#FDD6E3] hover:bg-[#FAB8CF]",
		default: "text-darkPurple bg-lightPurple hover:bg-primaryPurple",
	},
};
